import { DialogComponent, DialogOpenEvent } from '@theme/dialog';
import { CartAddEvent } from '@theme/events';

/**
 * Cart Drawer Component
 */
class CartDrawerComponent extends DialogComponent {
  #summaryThreshold = 0.5;

  connectedCallback() {
    super.connectedCallback();
    document.addEventListener(CartAddEvent.eventName, this.#handleCartAdd);
    this.addEventListener(DialogOpenEvent.eventName, this.#onDialogOpen);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    document.removeEventListener(CartAddEvent.eventName, this.#handleCartAdd);
    this.removeEventListener(DialogOpenEvent.eventName, this.#onDialogOpen);
  }

  #handleCartAdd = () => {
    if (this.hasAttribute('auto-open')) {
      this.showDialog();
    }
  };

  open() {
    this.showDialog();
  }

  close() {
    this.closeDialog();
  }

  #onDialogOpen = () => {
    this.#updateStickyState();
    injectUrgencyMessageInDrawer(this.refs?.dialog);
  };

  #updateStickyState() {
    const dialog = this.refs?.dialog;
    if (!dialog) return;

    const content = dialog.querySelector('.cart-drawer__content');
    const summary = dialog.querySelector('.cart-drawer__summary');

    if (!content || !summary) {
      dialog.setAttribute('cart-summary-sticky', 'false');
      return;
    }

    const ratio =
      summary.getBoundingClientRect().height /
      dialog.getBoundingClientRect().height;

    dialog.setAttribute(
      'cart-summary-sticky',
      ratio > this.#summaryThreshold ? 'false' : 'true'
    );
  }
}

if (!customElements.get('cart-drawer-component')) {
  customElements.define('cart-drawer-component', CartDrawerComponent);
}

/* =========================
   ⏳ URGENCY TIMER
========================= */

const CART_TIMER_KEY = 'cart_expiration_time';
const CART_DURATION = 10 * 60 * 1000;

function injectUrgencyMessageInDrawer(dialog) {
  if (!dialog) return;

  const title = dialog.querySelector('h2');
  if (!title) return;

  if (dialog.querySelector('.cart-urgency')) return;

  const urgency = document.createElement('div');
  urgency.className = 'cart-urgency';
  urgency.hidden = true;
  urgency.innerHTML = `
    <p class="cart-urgency__text">
      ⏳ <strong>Tu carrito está reservado por</strong>
      <span id="cart-timer">10:00</span>
    </p>
    <small class="cart-urgency__note">
      Completa tu compra antes de que expire el tiempo.
    </small>
  `;

  title.insertAdjacentElement('afterend', urgency);
  startCartTimer(urgency);
}

function startCartTimer(container) {
  const timerEl = container.querySelector('#cart-timer');
  if (!timerEl) return;

  let expirationTime = localStorage.getItem(CART_TIMER_KEY);

  if (!expirationTime) {
    expirationTime = Date.now() + CART_DURATION;
    localStorage.setItem(CART_TIMER_KEY, expirationTime);
  }

  container.hidden = false;

  const interval = setInterval(() => {
    const remaining = expirationTime - Date.now();

    if (remaining <= 0) {
      clearInterval(interval);
      timerEl.textContent = '00:00';
      localStorage.removeItem(CART_TIMER_KEY);
      return;
    }

    const minutes = Math.floor(remaining / 60000);
    const seconds = Math.floor((remaining % 60000) / 1000);

    timerEl.textContent = `${minutes}:${seconds
      .toString()
      .padStart(2, '0')}`;
  }, 1000);
}
